const FlatCardTitle = ({ children }: { children: React.ReactNode }) => {
  return (
    <h3 className="text-lg font-semibold flex items-center gap-2 mb-4">
      {children}
    </h3>
  )
}

export default FlatCardTitle
